var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-loading"},[_c('commonLoading'),_c('div',{staticClass:"title"},[_vm._v("玩命加载中..")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }